import { Subscription } from "rxjs";
import { CpxCardSignatureResponseInterface, CpxCardSignatureResponsePracticeLocationsInterface } from "./cpx-signature-response-interface";
import { SessionTypeEnum } from "src/app/services/cpx-handle/cpx-handle-service-abstract";

export interface CpxSessionInterface {
  cpxType: CpxTypeEnum;
  // vitaleSessionId: string;
  pinCode: string;
  name: string;
  monitoring: WebSocket;
  PracticeLocations: Array<CpxCardSignatureResponsePracticeLocationsInterface>;
  practiceSettingIndice: number;
  cardStatus: CpxCardStatusEnum;
  // Prénom du PS
  psGiven: string;
  // Nom du PS
  psName: string;
  dmpConnectSessionInfos?: CpxCardSignatureResponseInterface;
  // getSession: (type: SessionTypeEnum) => any;
  isSessionOpen: boolean | undefined,
  confidentialityLevel?: boolean;
  isInsiConnectorCreated?: boolean;
  isDmpConnectorCreated?: boolean;
}

export enum CpxTypeEnum {
  CPS = 'CPS',
  CPE = 'CPE',
  CPF = 'CPF',
  CERTIFICAT = 'CERTIFICAT',
}

export interface CpxCardInfoStatus {
  // Number of remaining PIN code inputs.
  i_nbInputLeft: number;
  // Card expiration date.
  s_validityDate: Date;
  // Serial number of the card.
  s_cardId: string;
  // CpxCardStatus enum for values
  i_cardStatus: CpxCardStatusEnum;
}

export interface CpxCardSignature {
  // base64 content of the RSA signature
  s_signature: string,
  // PEM signature certificate
  s_signatureCertificate: string
}

export enum CpxCardStatusEnum {
  "Carte absente" = 1,
  "Carte trouvée, il s’agit d’une carte réelle" = 3,
  "Carte trouvée, il s’agit d’une carte de test" = 4,
  "Carte trouvée, il s’agit d’une carte de démonstration" = 5,
}
